export async function traiterClientInterclub({
  codeClient,
  nomClient,
  groupe,
  supabaseClientActif
}) {
  if (!codeClient) return null;

  // 1. vérifier si existe déjà
  const { data: existant } = await supabaseClientActif
    .from("comptes_clients_interclub")
    .select("*")
    .eq("code_client", codeClient)
    .eq("groupe", groupe)
    .maybeSingle();

  if (existant) {
    return existant;
  }

  // 2. créer en "à valider"
  const { data, error } = await supabaseClientActif
    .from("comptes_clients_interclub")
    .insert({
      code_client: codeClient,
      nom_client: nomClient,
      groupe: groupe,
      statut: "a_valider"
    })
    .select()
    .single();

  if (error) {
    console.log("ERREUR CREATION CLIENT INTERCLUB :", error);
    return null;
  }

  return data;
}
/* =========================================================
   REACTIVATION CLIENTS INTERCLUB IGNORES
========================================================= */
export async function reactiverClientsInterclubIgnores({
  groupe,
  supabaseClientActif
}) {
  const { error } = await supabaseClientActif
    .from("comptes_clients_interclub")
    .update({ statut: "a_valider" })
    .eq("groupe", groupe)
    .eq("statut", "ignore");

  if (error) {
    console.log("ERREUR REACTIVATION CLIENTS IGNORES :", error);
    alert("Erreur lors de la réactivation des clients ignorés");
    return false;
  }

  alert("Clients ignorés réactivés");
  return true;
}